<script setup lang="ts">
import { useId } from 'vue';

/**
 * One layout for every labelled control, so a form in a module looks like a
 * form in the core.
 *
 * The id is generated and handed back through the slot rather than left to the
 * caller: a label whose `for` does not match anything is invisible breakage,
 * and it is the kind nobody notices without a screen reader.
 */
defineProps<{ label: string; hint?: string | undefined; error?: string | undefined }>();

const id = useId();
const hintId = `${id}-hint`;
const errorId = `${id}-error`;
</script>

<template>
	<div class="flex flex-col gap-1.5">
		<label :for="id" class="text-sm font-medium">{{ label }}</label>
		<slot
			:id="id"
			:described-by="
				[hint ? hintId : '', error ? errorId : ''].filter(Boolean).join(' ') || undefined
			"
			:invalid="error !== undefined"
		/>
		<p v-if="hint && !error" :id="hintId" class="text-muted text-xs">{{ hint }}</p>
		<p v-if="error" :id="errorId" class="text-warning text-xs">{{ error }}</p>
	</div>
</template>
